import * as z from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const RegenerateTransferDocumentsEvent = BaseLoanEvent.extend({
  type: z.literal('regenerateTransferDocuments'),
});
export type RegenerateTransferDocumentsEvent = z.infer<typeof RegenerateTransferDocumentsEvent>;
